import Vue from 'vue';
import { Component } from 'vue-property-decorator';
@Component({
  name: 'CmgSessionExpiredBar',
})
export default class CmgSessionExpiredBar extends Vue {
  onClickClose(): void {
    this.$appStore.state.ui.showSessionExpiredBanner = false;
  }
}
